import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import BlockView from "@/components/block/BlockView.vue";
import BlockTitleView from "@/components/block/BlockTitleView.vue";
import {reactive, onMounted, onUnmounted} from "vue";
import {mockArr, req} from "@/lib/util";
import emit from "@/lib/emit";
import {Modal} from "ant-design-vue";
import {useRouter} from "vue-router";
import {draft} from "@/app";


export default /*#__PURE__*/_defineComponent({
  __name: 'BlockDrafts',
  setup(__props) {


const router = useRouter()
const info = reactive({loading: false, drafts: []})

onMounted(() => {
  mockArr('activities/drafts', 'get', 0, 30, {
    draft_id: '@id',
    title: '@ctitle(6,28)',
    poster: "@pick(['https://b.s.mywsy.cn/media/image/template/80041ff1ba8345894d1840382eb5c883.gif', 'https://b.s.mywsy.cn/media/image/template/4241ae73b4f20f325be716512bf9d530.gif', 'https://b.s.mywsy.cn/media/image/template/c29f10ad83b333e0c0b923f77059bf8b.png'])",
    update_at: '@datetime',
  })
  info.loading = true
  emit.on('templates.progress.loaded', () => {
    req({
      url: 'activities/drafts', success: rs => {
        info.drafts = rs
        // if (rs.length > 0 && !draft.tip) {
        //   draft.tip = true
        //   Modal.confirm({
        //     okText: '继续', cancelText: '暂不编辑', autoFocusButton: 'ok',
        //     title: '提示', content: '是否继续上次编辑的草稿活动？', onOk() {
        //       router.push({path: '/editor', query: {draft_id: rs[0].draft_id}})
        //     }
        //   })
        // }
      }, complete: () => {
        info.loading = false
        emit.emit('templates.drafts.loaded')
      }
    })
  })
})

onUnmounted(() => {
  emit.off('templates.progress.loaded')
})

const onDeleteDraft = (draftId: string) => {
  req({
    url: 'activity/draft', method: 'delete', params: {draft_id: draftId}, success: () => {
      info.drafts = info.drafts.filter((d: any) => d.draft_id != draftId)
    }
  })
}


return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_typography_text = _resolveComponent("a-typography-text")!
  const _component_a_flex = _resolveComponent("a-flex")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_button_group = _resolveComponent("a-button-group")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!

  return (_openBlock(), _createBlock(BlockView, {
    spinning: info.loading
  }, {
    default: _withCtx(() => [
      _createVNode(BlockTitleView, null, {
        default: _withCtx(() => [
          _createTextVNode("活动草稿")
        ]),
        _: 1
      }),
      _createVNode(_component_a_list, {
        "data-source": info.drafts,
        split: "",
        bordered: "",
        pagination: {defaultPageSize:4,hideOnSinglePage:true,showSizeChanger:false}
      }, {
        renderItem: _withCtx(({ item }) => [
          _createVNode(_component_a_list_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_a_flex, { vertical: true }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_flex, {
                    gap: "small",
                    align: "center"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_avatar, {
                        src: item.poster
                      }, null, 8, ["src"]),
                      _createVNode(_component_a_typography_text, { style: {"flex":"1"} }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.title), 1)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_a_flex, { gap: "middle" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_typography_text, { type: "secondary" }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(`更新时间：${new Date(item.update_at).toLocaleString()}`), 1)
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_a_button_group, { size: "small" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (_ctx.$router.push({path:'/editor',query:{draft_id:item.draft_id}}))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("编辑")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]),
                          _createVNode(_component_a_button, {
                            onClick: ($event: any) => (onDeleteDraft(item.draft_id)),
                            danger: ""
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("删除")
                            ]),
                            _: 2
                          }, 1032, ["onClick"])
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 1
      }, 8, ["data-source"])
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})